import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { ListService } from "../../../../auth/service/list.service";
import { UtilsService } from "../../../../auth/service/utils.service";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { ICustomerType } from "../../../customer/customer.interface";

interface RowType {
  id: number;
  name: string;
  other: {
    code: string;
    use: string;
    default: boolean;
  };
}

@Component({
  selector: "app-invoice-row-type",
  templateUrl: "./invoice-row-type.component.html"
})


export class InvoiceRowTypeComponent implements OnInit {
  public contentHeader: IContentHeader;
  private list_type: string = "invoice_row_type";
  private rowTypes = [];
  public filteredRowTypes = [];
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public showModalError: boolean = false;
  public typeForm: RowType = {
    id: null,
    name: null,
    other: {
      code: null,
      use: null,
      default: false
    }
  };

  constructor(
    public listService: ListService,
    private _routerService: Router,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _modalService: NgbModal
  ) {
    this.contentHeader = {
      headerTitle: "MENU.ROW_TYPE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management"
          },
          {
            name: "MENU.ROW_TYPE",
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_invoice_row_type_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.load();
  }

  load() {
    this.listService.getList(this.list_type).then((result: any) => {
      this.rowTypes = result;
      this.filterTypes();
    });
  }

  modalOpen(modal: TemplateRef<any>, selectedType: any) {
    this._modalService.open(modal, {
      size: "md",
      centered: true
    });
    this.typeForm = {
      id: null,
      name: null,
      other: {
        code: null,
        use: null,
        default: false
      }
    };
    if (selectedType) {
      this.typeForm = selectedType;
    }
    this.showModalError = false;
  }

  filterTypes() {
    const key: string = this.searchKeyword.trim().toLowerCase();
    let filterItem: ICustomerType[] = this.rowTypes;
    if (key.length > 0) {
      filterItem = filterItem.filter((item: ICustomerType) => item.name.toLowerCase().trim().includes(key));
    }
    this.filteredRowTypes = filterItem;
  }

  isError(): boolean {
    this.showModalError =
      this.typeForm.name === null || this.typeForm.name.length < 1 || this.typeForm.other.code === null || this.typeForm.other.code.length < 1 || this.typeForm.other.use === null || this.typeForm.other.use.length < 1;
    return this.showModalError;
  }

  async addType() {
    if (!this._authenticationService.hasCapability("create_invoice_row_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .create(this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_ADD_ROW_TYPE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
            use: "",
            default: false
          }
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_ADD_ROW_TYPE");
      });
  }

  async editType() {
    if (!this._authenticationService.hasCapability("edit_invoice_row_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const idType: number = this.typeForm.id;
    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .update(idType, this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_EDIT_ROW_TYPE");
        this.typeForm = {
          id: null,
          name: null,
          other: {
            code: null,
            use: null,
            default: false
          }
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_EDIT_ROW_TYPE");
      });
  }

  async deleteType(selectedType: any) {
    if (!this._authenticationService.hasCapability("delete_invoice_row_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedType.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.listService.delete(selectedType.id, this.list_type).then(() =>
            this._utilService.showPopupItemDeleted().then(async () => {
              this.load();
              await this._utilService.showToastrSuccess("SUCCESS_DELETE_ROW_TYPE");
            })
          );
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT"
          });
        }
      })
      .catch(() => this._utilService.showToastrError("ERROR_DELETE_ROW_TYPE"));
  }
}
